import React, { Component } from 'react'
import { Modal } from "react-bootstrap";
import { Row, Col, Card, Button, Container, Form, Spinner, Table } from "react-bootstrap";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import "./_userManagement.scss"
import UnAssignOrAsssignLeadDetailsModal from './UnAssignOrAsssignLeadDetailsModal';

const ADD_OR_DELETE_LEADS = gql`
        mutation($params:AddOrDeleteLeads) {
            addOrDeleteLeads(params:$params)
        }   
    `;

class LeadManagement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            branch_id: "",
            branchError: "",
            assignedTo: "",
            assignedToError: "",
            getLeadsData: [],
            selectedOptionId: "1",
            search: "",
            currentPageStartCount: 0,
            currentPageEndCount: 10,
            loading: 0,
            selectAll: false,
            submitted: false,
            selectLeadData: [],
            employeesData: [],
            loadingSpinner: 0,
            currentStep: 1,
            dataClear: 1,
            submitError: "",
            type: "1",
            unassignedOrAssignedLeads: [],
            deleteCheckboxChecked: false,
            noDateError: "",
            submitMessage: "",
            submitMessageColor: "",

            UnAssignLeadDetailsModal: false,
            fieldsData: []

        };
    };

    componentDidMount() {
        let getArray1 = [];
        this.props.globals.globalBranches.map((item) => {
            const newObj = {
                value: item.id,
                label: item.branch_name
            }
            getArray1.push(newObj);
        });
        this.setState({
            branchSearchval: getArray1[0],
            branch_id: getArray1[0].value
        })

        this.getUnassignedAndAssignedLeads(getArray1[0].value);
        this.getLeadManagementEmployees(getArray1[0].value);
    }

    handleInputRadioChange = (val) => {

        if (this.state.getLeadsData.length > 0) {

            console.log("vvvv", val, this.state.getLeadsData[0]);

            if (val == "1") {
                this.setState({ unassignedOrAssignedLeads: this.state.getLeadsData[0].unAssigned_Leads, selectedOptionId: val, type: val, assignedTo: "", assignedToError: "", deleteCheckboxChecked: false, selectAll: false, search: "", submitError: "", selectLeadData: [] })
            } else {
                this.setState({ unassignedOrAssignedLeads: this.state.getLeadsData[0].assigned_Leads, selectedOptionId: val, type: val, assignedTo: "", assignedToError: "", deleteCheckboxChecked: false, selectAll: false, search: "", submitError: "", selectLeadData: [] })
            }
        } else {

            this.setState({ unassignedOrAssignedLeads: [], assignedTo: "", assignedToError: "", })
        }
    };

    handleBranchChange = (e) => {
        console.log("ddddddddddddd", e.target.value);
        let name = e.target.name
        let value = e.target.value
        if (name == "branch") {
            if (value != "" && value != "--Select Branch--") {
                this.setState({
                    branch_id: value,
                    branchError: "",
                    getLeadsData: [],
                    assignedTo: "",
                    assignedToError: "",
                    selectAll: false,
                    deleteCheckboxChecked: false,
                    submitError: "",
                    selectedOptionId: "1",
                    type: "1",
                    unassignedOrAssignedLeads: [],
                    search: "",
                    noDateError: ""
                })
            } else {
                this.setState({
                    branch_id: "",
                    branchError: "",
                    getLeadsData: [],
                    assignedTo: "",
                    assignedToError: "",
                    selectAll: false,
                    deleteCheckboxChecked: false,
                    submitError: "",
                    selectedOptionId: "1",
                    type: "1",
                    unassignedOrAssignedLeads: [],
                    search: "",
                    noDateError: ""
                })
            }
        }

    };

    getUnassignedAndAssignedLeads = async (val) => {
        console.log("val", val);
        this.setState({ loader: 1 })
        const result = await this.props.client.query({
            query: gql`
              query($institute_id:Int,$branch_id:Int){
                getUnassignedAndAssignedLeads(institute_id:$institute_id,branch_id:$branch_id){
                    unAssigned_Leads {
                        employee_id
                        employee_name
                        lead_name
                        lead_mobile
                        father_name
                        father_contact_no
                        lead_id
                        source_name
                    }
                    assigned_Leads {
                        employee_id
                        employee_name
                        lead_name
                        lead_mobile
                        father_name
                        father_contact_no
                        lead_id
                        source_name
                      }
                    }
                }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(val),
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getUnassignedAndAssignedLeads.length > 0) {

            console.log("dataaaaaaaaaaaaa", result.data.getUnassignedAndAssignedLeads);
            let data = result.data.getUnassignedAndAssignedLeads

            let unassignedOrAssignedLeads = data[0].unAssigned_Leads.length > 0 ? data[0].unAssigned_Leads : data[0].assigned_Leads.length > 0 ? data[0].assigned_Leads : [];
            let selectedOptionId = data[0].unAssigned_Leads.length > 0 ? "1" : data[0].assigned_Leads.length > 0 ? "2" : "0";
            let type = data[0].unAssigned_Leads.length > 0 ? "1" : data[0].assigned_Leads.length > 0 ? "2" : "0";



            this.setState({
                getLeadsData: data, loader: 0, submitted: true, unassignedOrAssignedLeads: unassignedOrAssignedLeads, selectedOptionId: selectedOptionId, type: type, submitMessage: "",
                submitMessageColor: "",
                assignedTo: "",
                assignedToError: "",
                selectAll: false,
                deleteCheckboxChecked: false,
                selectLeadData: []
            })

        } else {
            this.setState({
                loading: 0, loader: 0, noDateError: "No Data Available", unassignedOrAssignedLeads: [], getLeadsData: [], submitMessage: "",
                submitMessageColor: "",
                assignedTo: "",
                assignedToError: "",
                selectAll: false,
                deleteCheckboxChecked: false,
                selectLeadData: []
            })
        }
    };

    getLeadManagementEmployees = async (val) => {
        this.setState({ loader: 1 })
        const employeeData = await this.props.client.query({
            query: gql`
              query($institute_id:Int,$branch_id:Int){
                getLeadManagementEmployees(institute_id:$institute_id,branch_id:$branch_id){
                    employee_id
                    assigned_status
                    employee_name
                    emp_mobile                
                    }
                }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(val),
            },
            fetchPolicy: 'network-only'
        })

        if (employeeData.data.getLeadManagementEmployees.length > 0) {

            let data = employeeData.data.getLeadManagementEmployees.filter((a) => a.assigned_status == "assigned")
            console.log("data1111111111", data);
            this.setState({ employeesData: data })
        }
    };

    assignedToHandle = (e) => {
        let name = e.target.name
        let value = e.target.value
        console.log("value", value)
        if (name == "assigned") {
            this.setState({
                assignedTo: value,
                assignedToError: "",
                currentPageStartCount: 0,
                currentPageEndCount: 10,
            })
        }
    };

    handleSelectAllChange = () => {
        const { unassignedOrAssignedLeads, selectAll } = this.state;
        const updatedLeads = unassignedOrAssignedLeads.map(item => ({
            ...item,
            selected: !selectAll,
        }));

        const updatedSelectLeadData = updatedLeads.filter((lead) => lead.selected);

        this.setState({
            selectAll: !selectAll,
            unassignedOrAssignedLeads: updatedLeads,
            selectLeadData: updatedSelectLeadData,
            submitError: ""
        });
    };

    handleCheckboxChange = (item) => {
        const { unassignedOrAssignedLeads } = this.state;

        const updatedLeads = unassignedOrAssignedLeads.map((lead) => ({
            ...lead,
            selected: lead === item ? !lead.selected : lead.selected,
        }));

        const updatedSelectLeadData = updatedLeads.filter((lead) => lead.selected);
        const allSelected = updatedLeads.every((lead) => lead.selected);
        console.log("allSelected", allSelected);

        this.setState({
            unassignedOrAssignedLeads: updatedLeads,
            selectLeadData: updatedSelectLeadData,
            selectAll: allSelected,
            submitError: "",
        });
    };

    searchFilter = (e) => {
        let value = e.target.value
        console.log("elllllll", value);
        this.setState({ search: value, currentPageStartCount: 0, currentPageEndCount: 10 })
    };

    pageChange = (pageNumber) => {
        console.log("pageNumber", pageNumber);
        this.setState({
            currentPageStartCount: (+pageNumber - 1) * 10,
            currentPageEndCount: +pageNumber * 10
        })
    }

    handleSubmit = () => {

        if (this.state.type == "3") {

            if (this.state.selectLeadData.length == 0) {
                this.setState({ submitError: "Please select at least one lead.", loadingSpinner: 0 });
                return;
            }

            let array = [];
            let employeeArray = [];

            this.state.selectLeadData.map((item) => {
                array.push({ lead_id: item.lead_id });
                employeeArray.push({ employee_id: item.employee_id });
            });

            const params = {
                type: parseInt(this.state.type),
                assigned_emp_id: this.state.type == "3" ? parseInt(employeeArray) : parseInt(this.state.assignedTo),
                inserted_by: parseInt(Cookies.get("id")),
                lead_detatils: array
            };

            this.setState({
                loadingSpinner: 1
            });

            this.addOrDeleteLeads(params).catch((error) => {
                console.log("catch if error");
                console.log(error);
                this.setState({
                    submitError: error.graphQLErrors.map((x) => x.message),
                    loadingSpinner: 0
                });
                console.error("ERR =>", error.graphQLErrors.map((x) => x.message));
            });
        } else {

            if (this.state.selectLeadData.length == 0) {
                this.setState({ submitError: "Please select at least one lead.", loadingSpinner: 0 });
                return;
            }

            if (this.state.assignedTo == "") {
                this.setState({ assignedToError: "Please Select Assigned Leads To" });
                return "";
            }

            let array = [];

            this.state.selectLeadData.map((item) => {
                array.push({ lead_id: item.lead_id });
            });

            const params = {
                type: parseInt(this.state.type),
                assigned_emp_id: parseInt(this.state.assignedTo),
                inserted_by: parseInt(Cookies.get("id")),
                lead_detatils: array
            };

            console.log("params", params);
            this.setState({
                loadingSpinner: 1
            });

            this.addOrDeleteLeads(params).catch((error) => {
                console.log("catch if error");
                console.log(error);
                this.setState({
                    submitError: error.graphQLErrors.map((x) => x.message),
                    loadingSpinner: 0
                });
                console.error("ERR =>", error.graphQLErrors.map((x) => x.message));
            });
        }
    };

    addOrDeleteLeads = async (
        params) => {
        await this.props.addOrDeleteLeads({
            variables: {
                params,
            },
            update: (store, { data }) => {
                console.log("data.finishTest", data);
                if (data.addOrDeleteLeads) {

                    let successMessage = "";
                    let messageColor = "";

                    if (params.type == 1) {
                        successMessage = "Leads Assign Successfully";
                        messageColor = "successColorGreen"
                    } else if (params.type == 2) {
                        successMessage = "Leads Update Successfully";
                        messageColor = "successColorGreen"
                    } else if (params.type == 3) {
                        successMessage = "Leads Unassign Successfully";
                        messageColor = "deleteColorRed"
                    }

                    this.setState({
                        loadingSpinner: 0,
                        currentStep: 5,
                        submitMessage: successMessage,
                        submitMessageColor: messageColor
                    })
                    setTimeout(() => {
                        this.getUnassignedAndAssignedLeads(this.state.branch_id);
                    }, 1500)

                }
            }
        });
    };

    handleDeleteCheckboxChange = () => {
        this.setState((prevState) => ({
            deleteCheckboxChecked: !prevState.deleteCheckboxChecked,
            type: prevState.deleteCheckboxChecked ? "1" : "3",
            assignedTo: "",
            assignedToError: "",
            submitError: "",
        }));
    };

    handleGetLeads = (e) => {
        e.preventDefault();

        if (this.state.branch_id == "") {
            this.setState({ branchError: "Please Select Branch" });
            return ""
        }

        this.getUnassignedAndAssignedLeads(this.state.branch_id);
        this.getLeadManagementEmployees(this.state.branch_id);
    }

    getFormFieldsData = async (val) => {

        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int, $branch_id:Int, $lead_id:Int! ) {
                getFormFieldsData(institute_id:$institute_id, branch_id:$branch_id, lead_id: $lead_id) {
                    form_fields_id
                    form_field_name
                    lead_id
                    lead_mobile
                    lead_name
                    value
                }
              }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branch_id),
                lead_id: parseInt(val),
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getFormFieldsData.length > 0) {
            let data = result.data.getFormFieldsData;
            this.setState({ fieldsData: data })
        } else {
            this.setState({ fieldsData: [] })
        }
    }

    unAssignOrAssignLeadDetails = (row) => {
        this.getFormFieldsData(row.lead_id)
        setTimeout(() => {
            this.setState({
                UnAssignLeadDetailsModal: true,
            })
        }, 700)
    };

    render() {
        console.log("propsData", this.props);
        console.log("stateData", this.state);
        // console.log("assigeeeee", this.state.getLeadsData[0].unAssigned_Leads);

        let filterStudentData = this.state.unassignedOrAssignedLeads;

        if (this.state.search != "") {
            filterStudentData = this.state.unassignedOrAssignedLeads.filter((item) => item.lead_mobile.includes(this.state.search) || item.lead_name.toLowerCase().includes(this.state.search.toLocaleLowerCase()))
        } else {
            filterStudentData = this.state.unassignedOrAssignedLeads
        }

        let startNumber = 0
        let endNumber = filterStudentData.length;
        console.log("endNumber", endNumber);

        let pages = Math.ceil(endNumber / 10);

        let pagewiseFilterData = filterStudentData.filter((item, index) => index >= this.state.currentPageStartCount && index < this.state.currentPageEndCount);

        console.log("pages", startNumber, endNumber, pages);

        return (
            <section>
                <Container>
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12} className="mt-3">
                            <Card>
                                <Card.Body>
                                    <Form>
                                        <Form.Row>
                                            <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectBranch">
                                                <Form.Label className="font-weight-bold">Branch</Form.Label>
                                                <Form.Control as="select" name="branch" onChange={this.handleBranchChange} value={this.state.branch_id} >
                                                    <option >--Select Branch--</option>
                                                    {this.props.globals.globalBranches.map(branchData => (
                                                        <option value={branchData.id}>{branchData.branch_name}</option>
                                                    ))}
                                                </Form.Control>
                                                <Form.Text className="form-text text-danger" type="invalid">
                                                    {this.state.branchError}
                                                </Form.Text>
                                            </Form.Group>
                                            <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectBranch" >
                                                <div className="mt-4">
                                                    <button className="getEmployeeDetails mt-1" onClick={this.handleGetLeads} >GET LEADS</button>
                                                </div>
                                            </Form.Group>
                                        </Form.Row>
                                    </Form>
                                    <Row>
                                        {
                                            this.state.getLeadsData.length > 0 ? (
                                                <Col as={Col} lg={12} md={12} sm={12}>
                                                    <div className='d-flex justify-content-end radioButtons'>
                                                        <div className='mt-1'>
                                                            {
                                                                this.state.getLeadsData[0].unAssigned_Leads.length > 0 ? (
                                                                    <Form.Check type="radio" name="radioOption" id="1" label="Un Assign Leads" className="mr-3  RadioButtons h6" onClick={() => { this.handleInputRadioChange("1") }} checked={this.state.selectedOptionId == "1"} style={{ cursor: "pointer" }} />

                                                                ) : ("")
                                                            }
                                                            {
                                                                this.state.getLeadsData[0].assigned_Leads.length > 0 ? (
                                                                    <Form.Check type="radio" name="radioOption" id="2" label="Assign Leads" className='RadioButtons2 h6' onClick={() => { this.handleInputRadioChange("2") }} checked={this.state.selectedOptionId == "2"} style={{ cursor: "pointer" }} />

                                                                ) : ("")
                                                            }
                                                        </div>
                                                    </div>
                                                </Col>
                                            ) : ("")
                                        }
                                    </Row>
                                    {
                                        <div className={this.state.loader == 1 ? "d-flex align-items-center spinner-border text-primary text-center loading-img-center" : ""}></div>
                                    }
                                    <Row className='mt-3'>
                                        <Col as={Col} lg={12} md={12} sm={12}>
                                            {
                                                this.state.getLeadsData.length > 0 ? (
                                                    <>
                                                        {
                                                            this.state.getLeadsData.length > 0 ? (
                                                                <>
                                                                    <Row>
                                                                        <Col as={Col} lg={4} md={12} sm={12}>
                                                                            <Form.Group as={Col} controlId="formSearch">
                                                                                <Form.Control type="text" placeholder="Search" name='search' onChange={(e) => this.searchFilter(e)} />
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col sm={12}>
                                                                            <div className="leads_table">
                                                                                <Table bordered className="text-center leads_table">
                                                                                    <thead className='table-header'>
                                                                                        <tr>
                                                                                            <th><input type="checkbox" className="custom-checkbox1" checked={this.state.selectAll}
                                                                                                onChange={this.handleSelectAllChange} style={{ cursor: "pointer" }} /> Select All</th>
                                                                                            <th>Lead Name</th>
                                                                                            <th>Lead Mobile</th>
                                                                                            {/* <th>Father Name</th>
                                                                                            <th>Father Mobile</th> */}
                                                                                            <th>Source</th>
                                                                                            {this.state.selectedOptionId == "2" && <th>Assigned Employee</th>}
                                                                                            {/* {this.state.selectedOptionId == "2" && <th>Action</th>} */}
                                                                                        </tr>
                                                                                    </thead>
                                                                                    {
                                                                                        pagewiseFilterData.length > 0 ? (
                                                                                            <tbody>
                                                                                                {
                                                                                                    pagewiseFilterData.map((item) => {
                                                                                                        return (
                                                                                                            <>
                                                                                                                <tr key={item.id}>
                                                                                                                    <td>
                                                                                                                        <input
                                                                                                                            style={{ cursor: "pointer" }}
                                                                                                                            type="checkbox"
                                                                                                                            checked={item.selected || false}
                                                                                                                            onChange={() => this.handleCheckboxChange(item)}
                                                                                                                        />
                                                                                                                    </td>
                                                                                                                    <td onClick={() => this.unAssignOrAssignLeadDetails(item)} style={{ cursor: "pointer"}}><a href='#' style={{ color: "#000", textDecoration: "none" }}
                                                                                                                        onMouseEnter={(e) => e.target.style.textDecoration = "underline"}
                                                                                                                        onMouseLeave={(e) => e.target.style.textDecoration = "none"}>{item.lead_name || '-'}</a></td>
                                                                                                                    <td>{item.lead_mobile || '-'}</td>
                                                                                                                    {/* <td>{item.father_name || '-'}</td>
                                                                                                                    <td>{item.father_contact_no || '-'}</td> */}
                                                                                                                    <td>{item.source_name || '-'}</td>
                                                                                                                    {this.state.selectedOptionId == "2" && <td>{item.employee_name || '-'}</td>}
                                                                                                                </tr>
                                                                                                            </>
                                                                                                        )
                                                                                                    })
                                                                                                }
                                                                                            </tbody>
                                                                                        ) : (
                                                                                            <tr>
                                                                                                <td colSpan="7" className='text-center'>
                                                                                                    <h6 className='mt-3'>No data available</h6>
                                                                                                </td>
                                                                                            </tr>
                                                                                        )
                                                                                    }
                                                                                </Table>
                                                                            </div>
                                                                            <Row>
                                                                                <Col className="d-flex justify-content-end mr-3 mb-3">
                                                                                    {
                                                                                        Array.from({ length: pages }, (_, index) => {
                                                                                            return (
                                                                                                <p className={this.state.currentPageStartCount / 10 == index ? "ml-2 pagesIndex active" : "ml-1 pagesIndex"} onClick={() => this.pageChange(index + 1)}>{index + 1}</p>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </Col>
                                                                            </Row>
                                                                        </Col>
                                                                    </Row>
                                                                    {
                                                                        pagewiseFilterData.length > 0 ? (
                                                                            <Row>
                                                                                <Col as={Col} lg={4} md={12} sm={12}>
                                                                                    {
                                                                                        this.state.selectedOptionId == "2" ? (
                                                                                            <>
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    id="deleteCheckbox"
                                                                                                    checked={this.state.deleteCheckboxChecked}
                                                                                                    onChange={this.handleDeleteCheckboxChange}
                                                                                                    className='ml-5 mb-4'
                                                                                                    style={{ width: "35px", cursor: "pointer", height: "15px" }}
                                                                                                />
                                                                                                <label htmlFor="deleteCheckbox" className='mt-4' style={{ cursor: "pointer", fontSize: "15px" }}>
                                                                                                    Un Assign
                                                                                                </label>
                                                                                            </>
                                                                                        ) : ("")
                                                                                    }</Col>
                                                                                <Col as={Col} lg={4} md={12} sm={12}>
                                                                                    {
                                                                                        !this.state.deleteCheckboxChecked && this.state.getLeadsData.length > 0 ? (
                                                                                            <>
                                                                                                <h6>Assign To</h6>
                                                                                                <Form.Control as="select" name="assigned" style={{ width: "185px" }} onChange={this.assignedToHandle} value={this.state.assignedTo}>
                                                                                                    <option value="">Select</option>
                                                                                                    {this.state.employeesData.map(item => (
                                                                                                        <option value={item.employee_id}>{item.employee_name}</option>
                                                                                                    ))}
                                                                                                </Form.Control>
                                                                                                <Form.Text className="form-text text-danger mr-3">
                                                                                                    {this.state.assignedToError}
                                                                                                </Form.Text>
                                                                                            </>
                                                                                        ) : ("")
                                                                                    }
                                                                                </Col>
                                                                                <Col as={Col} lg={4} md={12} sm={12} className="d-flex justify-content-end align-items-center">
                                                                                    {this.state.currentStep == 5 ? (
                                                                                        <Form.Text className={`form-text mb-2 ${this.state.submitMessageColor}`}>
                                                                                            {this.state.currentStep == 5 && this.state.submitMessage}
                                                                                        </Form.Text>
                                                                                    ) : (
                                                                                        <Form.Text className="form-text text-danger mb-2">
                                                                                            {this.state.submitError}
                                                                                        </Form.Text>
                                                                                    )}

                                                                                    <button className="px-4 text-center submitButton" onClick={this.handleSubmit}>
                                                                                        {
                                                                                            this.state.loadingSpinner == 1 ? (
                                                                                                <span className="spinner-border spinner-border-sm"></span>
                                                                                            )
                                                                                                : ""
                                                                                        }
                                                                                        {this.state.deleteCheckboxChecked ? "UN ASSIGN" : "ASSIGN"}</button>
                                                                                </Col>
                                                                            </Row>
                                                                        ) : ("")
                                                                    }
                                                                </>
                                                            ) : (
                                                                <Row>
                                                                    <Col ls={12} md={12} sm={12}>
                                                                        <h6 className='mt-3 text-center'>No data available</h6>
                                                                    </Col>
                                                                </Row>
                                                            )
                                                        }
                                                    </>
                                                ) : (
                                                    <Col sm={12}>
                                                        {
                                                            this.state.noDateError != "" ?
                                                                (
                                                                    <h6 className='d-flex justify-content-center align-content-center'>{this.state.noDateError}</h6>
                                                                ) : ("")
                                                        }
                                                    </Col>
                                                )
                                            }
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <UnAssignOrAsssignLeadDetailsModal
                    stateData={this.state}
                    show={this.state.UnAssignLeadDetailsModal}
                    onHide={() => this.setState({ UnAssignLeadDetailsModal: false })}
                />
            </section>
        )
    }
}

export default withRouter(withApollo(compose(
    graphql(ADD_OR_DELETE_LEADS, {
        name: "addOrDeleteLeads"
    }),
)(LeadManagement)));